/**
 * Business details shown in the Terms, Privacy Policy and Refund Policy.
 * Bump TERMS_VERSION (and accounts.TERMS_VERSION in the backend) when the terms change.
 */

export const TERMS_VERSION = '2026-10-13';
export const LEGAL_LAST_UPDATED = '13 October 2026';

export const BUSINESS = {
  productName: 'Technical Interviewer',
  legalName: 'MacAnderson Uche',
  address: '8 Alexandra Terrace, TF1 1NF, United Kingdom',
  companyNumber: '',
  contactEmail: 'hi@macandersonuche.dev',
  vatNote: 'We are not VAT registered, so no VAT is charged',
};
